// src/pages/Home.jsx
import React from 'react';
import Banner from '../components/Banner';
import TrainingSection from '../components/TrainingSection';
import AboutSection from '../components/AboutSection';
import CountrySection from '../components/CountrySection';
import AboutSection2 from '../components/AboutSection2';
import ProcessSection from '../components/ProcessSection';
import GallerySection from '../components/GallerySection';
import TeamData from '../components/TeamData';
import WhyChooseUs from '../components/WhyChooseUs';
import FunFact from '../components/FunFact';
import Testimonials from '../components/Testimonials';
import ClientsSection from '../components/ClientsSection';
import NewsSectionTwo from '../components/NewsSectionTwo';
import FaqsSection from '../components/FaqsSection';

const Home = () => {
  return (
    <>
      <Banner />
      <TrainingSection />
      <AboutSection />
      <CountrySection />
      <AboutSection2 />
      <ProcessSection />
      <GallerySection />
      <TeamData />
      <WhyChooseUs />
      <FunFact />
      <Testimonials />
      <ClientsSection />
      <NewsSectionTwo />
      <FaqsSection />
    </>
  );
};

export default Home;